import { Component, Input, OnInit } from '@angular/core';
import { NodeDto, TreeNode } from '../../models/hierarchy.model';
import { HierarchyService } from '../../services/hierarchy.service';
import { ViewTreeService } from '../../services/tree/node-tree.service';

@Component({
  selector: 'vfs-hierarchy-tree-widget',
  templateUrl: './hierarchy-tree-widget.component.html',
  styleUrls: ['./hierarchy-tree-widget.component.scss'],
  providers: [ViewTreeService]
})
export class HierarchyTreeWidgetComponent implements OnInit {
  @Input() nodes: NodeDto[];
  @Input() elementId: string = null;

  rootNode: NodeDto = null;

  constructor(public treeService: ViewTreeService, protected hierarchyService: HierarchyService) {}

  ngOnInit(): void {
    this.rootNode = this.nodes.find(node => node.parentId === null);
    this.treeService.initialize();
    this.treeService.dataSource.initializeWithNodes(this.nodes);
  }

  checkDatasourceContainsData() {
    return (
      !this.treeService.dataSource ||
      this.treeService.dataSource.data.length === 0 || // Searching not have nodes
      (this.treeService.dataSource.data.length > 0 && // Empty has root node
        this.treeService.dataSource.data[0].childrenCount === 0 &&
        this.treeService.dataSource.data[0].item.nodeTypeId === this.rootNode.nodeTypeId)
    );
  }

  hasChild(node: TreeNode) {
    return this.treeService.isExpandable(node);
  }

  loadMore(node: TreeNode) {
    this.treeService.dataSource.loadMore(node);
  }

  getSelectedElementId(node: NodeDto): boolean {
    return this.elementId !== null && node.nodeElementId === this.elementId;
  }
}
